<template lang="html">
  <div class="cookies" v-show="cookiesShow">
    <div class="text-left">
      {{translation.header.cookies}}
      <span class="text-left">
        <router-link :to="{name:'privacy-policy', params:{ lang: lang}}">{{translation.header.cookiesButton}}</router-link>
      </span>
      <button @click="cookiesFn" name="button btn">{{translation.header.cookiesClose}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cookies',
  data(){
    return {
      translation: message,
      cookiesShow: true,
      lang: window.lang
    }
  },
  created(){
    if (localStorage.getItem('showCookie')) {
      this.cookiesShow = false;
    }else{
      this.cookiesShow = true;
    }
  },
  methods: {
    cookiesFn: function(){
      localStorage.setItem('showCookie',true)
      this.cookiesShow = false;
    }
  }
}
</script>

<style lang="css" scoped>
 .cookies{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
    color: #fff;
  background: #fff;
  z-index: 1000;
}
 .cookies div{
  padding: 1em;
  background: rgba(48, 87, 176, 0.9);
}

 .cookies div span{
  margin-left: 1em;
}
 .cookies div span a{
  color: #fff;
  text-decoration: underline;
}
 .cookies div  button{
  position: absolute;
  right: 1em;
  background: #FE7154;
  padding-left: 1.5em;
  padding-right: 1.5em;
  border: none;
  outline: none;
  border-radius: 5em;
}
</style>
